import { Component, Inject } from '@angular/core';
import { Representative } from 'src/app/shared/models/representative.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  Originator,
  OriginatorCreationRequestFields,
} from 'src/app/shared/models/originator.model';
import { Account } from 'src/app/shared/models/accounts.model';
import { CNPJ_MASK, CPF_MASK } from 'src/app/shared/constants';
import { NgxMaskPipe } from 'ngx-mask';
import { CurrentAccountDialog } from 'src/app/shared/models/current-account.model';
import { AssignorAgents } from '../../models';
import { mapAssignorAgentToRepresentative } from './mapper/representative.mapper';

@Component({
  selector: 'app-summary-dialogs',
  templateUrl: './summary-dialogs.component.html',
  styleUrls: ['./summary-dialogs.component.scss'],
})
export class SummaryDialogComponent {
  representantes: Representative[] = [];
  contasCorrentes: CurrentAccountDialog[] = [];
  originadores: OriginatorCreationRequestFields[] = [];

  maskpipe;
  cnpj_mask = CNPJ_MASK;
  cpf_mask = CPF_MASK;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      dataRepre?: Representative[] | AssignorAgents[];
      dataAccounts?: CurrentAccountDialog[];
      dataOrigin?: OriginatorCreationRequestFields[];
    },
    private maskPipe: NgxMaskPipe
  ) {
    this.maskpipe = maskPipe;
  }

  ngOnInit() {
    this.loadRepresentantes(this.data.dataRepre);
    this.getAccounts(this.data.dataAccounts);
    this.getOrigin(this.data.dataOrigin);
  }

  getAccounts(dataAccounts: CurrentAccountDialog[]): void {
    this.contasCorrentes = dataAccounts;
  }

  getOrigin(dataOrigin: OriginatorCreationRequestFields[]): void {
    this.originadores = dataOrigin;
  }

  private loadRepresentantes(data: Representative[] | AssignorAgents[]): void {
    if (data?.length && 'nomeRepresentante' in data[0]) {
      // Convertendo de AssignorAgents para Representative
      this.representantes = (data as AssignorAgents[]).map(mapAssignorAgentToRepresentative);
    } else {
      this.representantes = data as Representative[];
    }
  }
}
